import { j as e } from "../../../_virtual/jsx-runtime.js";
import n from "react";
import d from "../../../assets/icons/Search.js";
import { cn as m, debounce as p } from "../../../lib/utils.js";
const i = n.forwardRef(
  ({ defaultValue: r, onChange: a, placeholder: t = "Search", inputClassName: o }, l) => {
    const s = (c) => {
      a(c.target.value);
    };
    return /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ e.jsx(d, { className: "absolute left-4 top-1/2 -translate-y-1/2" }),
      /* @__PURE__ */ e.jsx(
        "input",
        {
          type: "text",
          defaultValue: r,
          onChange: p(s, 800),
          placeholder: t,
          className: m(
            "w-full h-10 pl-11 pr-4 text-base rounded-full border border-black outline-none placeholder:text-gray-600 placeholder:text-sm focus:border-black transition-colors",
            o
          ),
          ref: l
        }
      )
    ] });
  }
);
i.displayName = "SearchBar";
export {
  i as default
};
